// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___2iqET","body":"body___GOOPM"};